import { motion } from 'framer-motion';

/**
 * PageTransition — wraps page content with smooth entry/exit animations.
 *
 * Variants:
 *  - 'rise'    : fades in + rises slightly from below (default, great for main pages)
 *  - 'slide'   : slides in from the right (drill-downs: list → detail)
 *  - 'fade'    : simple opacity fade (lightweight)
 */

const variants = {
    rise: {
        initial: { opacity: 0, y: 18, scale: 0.99 },
        animate: { opacity: 1, y: 0, scale: 1 },
        exit: { opacity: 0, y: -8, scale: 0.99 },
    },
    slide: {
        initial: { opacity: 0, x: 28 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -14 },
    },
    fade: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
    },
};

const transition = {
    duration: 0.24,
    ease: [0.4, 0, 0.2, 1],
};

const PageTransition = ({ children, variant = 'rise' }) => {
    const v = variants[variant] || variants.rise;

    return (
        <motion.div
            initial={v.initial}
            animate={v.animate}
            exit={v.exit}
            transition={transition}
            style={{ willChange: 'opacity, transform', minHeight: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;
